import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

@createModule('AddToCalendar')
/**
 * AddToCalendar Component
 * @constructor
 */
export class AddToCalendar extends TerrificSpec {
	/**
	 * start/init Nitro lifecycle hook
	 * @param {function} resolve - Required parameter for start lifecycle
	 * @returns {void} void
	 */
	start(resolve: () => void): void {
		setTimeout(() => {

            $(".addeventatc").css("text-decoration", "none");

        }, 1000);
		resolve();
	}

	/**
	 * stop/destroy Nitro lifecycle hook
	 * @returns {void}
	 */
	stop() {
	}

}
